import { graphql } from '@/gql';
import type { CreateSmsTemplateMutation, CreateSmsTemplateMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type CreateSmsTemplateInput = CreateSmsTemplateMutationVariables;

export type CreateSmsTemplateOutput = CreateSmsTemplateMutation['createSmsTemplate'];

export const createSmsTemplate = async ({ name, template }: CreateSmsTemplateInput): Promise<CreateSmsTemplateOutput> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateSmsTemplate($name: String!, $template: String!) {
        createSmsTemplate(name: $name, template: $template) {
          id
          name
          template
          createdAt
          updatedAt
        }
      }
    `),
    variables: {
      name,
      template,
    },
  });

  return response.data!.createSmsTemplate;
};
